import React, { useEffect } from 'react'
import { useLocation } from "react-router-dom";

export default function Expertise() {
      const location = useLocation();
      useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        // Scroll smoothly after short delay
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      }
    }
  }, [location]);
  return (
    <div className='container pt-6 pb-6'>
        <h2 style={{color: "#767676"}}>OUR AREAS OF EXPERTISE</h2>
        <div style={{display: "flex", alignContent:"center", justifyContent:"left", flexWrap:"wrap"}}>
        <a href='#tax' style={{border: "1px solid", padding: "5px 8px", color:"white", background:"darkblue", margin:"5px 10px", borderRadius:"4px"}}>Tax Matter</a>
        <a href='#financial' style={{border: "1px solid", padding: "5px 8px", color:"white", background:"darkblue", margin:"5px 10px", borderRadius:"4px"}}>Financial Services</a>
        <a href='#corporate' style={{border: "1px solid", padding: "5px 8px", color:"white", background:"darkblue", margin:"5px 10px", borderRadius:"4px"}}>Corporate Services</a>
        <a href='#property' style={{border: "1px solid", padding: "5px 8px", color:"white", background:"darkblue", margin:"5px 10px", borderRadius:"4px"}}>Intellectual Property Services</a>
        <a href='#banking' style={{border: "1px solid", padding: "5px 8px", color:"white", background:"darkblue", margin:"5px 10px", borderRadius:"4px"}}>Banking and Finance</a>
        <a href='#commercial' style={{border: "1px solid", padding: "5px 8px", color:"white", background:"darkblue", margin:"5px 10px", borderRadius:"4px"}}>Commercial</a>
        <a href='#water' style={{border: "1px solid", padding: "5px 8px", color:"white", background:"darkblue", margin:"5px 10px", borderRadius:"4px"}}>Water & Power</a>
        <a href='#realestate' style={{border: "1px solid", padding: "5px 8px", color:"white", background:"darkblue", margin:"5px 10px", borderRadius:"4px"}}>Real Estate Development and Construction</a>
        <a href='#dispute' style={{border: "1px solid", padding: "5px 8px", color:"white", background:"darkblue", margin:"5px 10px", borderRadius:"4px"}}>Dispute Resolution</a>
        </div>
        <h4 id='tax' className='mt-4 text-uppercase'>Tax Matters:</h4>
        <p style={{textAlign:"justify"}}>
         The firm is deeply involved in all kind of tax matters that primarily
        includes matters pertaining to income tax, sales tax, withholding tax, advance tax and
        all sort of transactional and indirect taxes. Firm specializes in dealing with tax related
        disputes and litigations that include but not limited to tax reviews, tax audits, tax
        appeals, and tax litigations.
        </p> 
        
        <h4 id='financial' className='text-uppercase'>Financial Services:</h4>
        <p style={{textAlign:"justify"}}>
         The firm specialize in all scope of accounting and book-keeping
        services that includes proprietary accounts, partnership accounts and corporate
        accounts that ranges form owner managed businesses to listed corporations and
        include all kind of industries. Firm takes pride in preparing annual accounts and
        financial statements that range from management reports to financial statements
        compliant of IFRS and notes thereto.
        </p> 

        <h4 id='corporate' className='text-uppercase'>Corporate Services:</h4>
        <p style={{textAlign:"justify"}}>
          The firm has extensive experience in provide corporate and
            management related services, including but not limited to, regulatory compliance
            services, labor compliance services, employee insurance and old age benefit
            compliance services, management training services, payroll training services, and
            corporate restructures.
        </p>   

        <h4 id='property' className='text-uppercase'>Intellectual Property Services:</h4>
        <p style={{textAlign:"justify"}}>
        The firm advises on intellectual property rights,
        including but not limited to, registration(s) of Trademark(s), Copyright(s) and
        Patent(s), finding remedies for dispute(s) relating illegal adoption of Trademark(s),
        Copyright(s) and Patent(s).
        </p> 

        <h4 id='banking' className='text-uppercase'>Banking and Finance: </h4>
        <p style={{textAlign:"justify"}}>
        The firm has substantial experience in banking and finance,
        having pioneered various innovative financing transactions under the non-interest
        mode of finance and under various rules and regulations of the State Bank of Pakistan.
        The firm has, over time, represented various banks before any and all fora(s) for
        disputes relating to recovering the amounts from defaulters.
        </p> 

        <h4 id='commercial' className='text-uppercase'>Commercial: </h4>
        <p style={{textAlign:"justify"}}>
        The firm has unique expertise in advising various local and
        multinational companies on corporate matters. The firm has undertaken various
        mergers and acquisitions for various clients. The firm regularly represents in clients in
        drafting and negotiating contracts, including vendor supply contracts, joint ventures and concession agreements etc.
        </p> 

        <h4 id='water' className='text-uppercase'>Water & Power: </h4>
        <p style={{textAlign:"justify"}}>
        The firm is assisting various clients from telecommunication, power
        and energy sectors such as Telenor, Central Power Purchasing Agency Guarantee
        Limited and National Transmission & Dispatch Company. The firm has also advised
        clients in establishing greenfield projects in diverse sectors such as telecommunication,
        textiles, cement, power and energy. 
        </p>  

        <h4 id='realestate' className='text-uppercase'>Real Estate Development and Construction: </h4>
        <p style={{textAlign:"justify"}}>
        The firm has a strong team specializing
        in all aspects of the real estate development and construction industry and regularly
        advises major players in this sector, which includes realtors, builders and developers.
        The firm has also rendered services to Land providers of Ravi Urban Development
        Authority (RUDA).
        </p>  

        <h4 id='dispute' className='text-uppercase'>Dispute Resolution:  </h4>
        <p style={{textAlign:"justify"}}>
        The firm believes in robust litigation practice representing
        multiple clients from the public and private sectors. The firm has represented such
        clients before judicial and quasi-judicial forums. The firm focuses on constitutional
        remedies, power and energy sector disputes, sales tax and customs duty disputes and
        banking and corporate litigation. The firm has a number of international clients who
        are currently being represented at various forums in Pakistan.
        </p>    
    </div>
  )
}
